import { Pipe } from '@angular/core';
import { isArray } from '../utils/utils';
var InitialPipe = (function () {
    function InitialPipe() {
    }
    InitialPipe.prototype.transform = function (input) {
        if (!isArray(input)) {
            return input;
        }
        return input.slice(0, input.length - 1);
    };
    return InitialPipe;
}());
export { InitialPipe };
InitialPipe.decorators = [
    { type: Pipe, args: [{
                name: 'initial'
            },] },
];
/** @nocollapse */
InitialPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=initial.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/array/initial.pipe.js
// module id = 237
// module chunks = 103